import React from 'react';
import Upload from 'jbc-front/components/icons/Upload';

import styles from './Download.scss';

export default props => <Upload className={styles.icon} {...props} />;
